export const PUT_PRICES = "PUT_PRICES";
export const PUT_PRICES_SUCCESS = "PUT_PRICES_SUCCESS";
export const PUT_PRICES_ERROR = "PUT_PRICES_ERROR";

export const GET_PRICES = "GET_PRICES";
export const GET_PRICES_SUCCESS = "GET_PRICES_SUCCESS";
export const GET_PRICES_ERROR = "GET_PRICES_ERROR";
